import { RootState } from '../store';
import { createSelector } from '@reduxjs/toolkit';
import { ModalSliceType } from '../slices/modal';
import { selectorArg1, selectorArg2 } from '../utils/selectors';

export const selectModalState = (rootState: RootState) => rootState.modal;

export const selectOpenedModalType = createSelector(
  selectModalState,
  selectorArg1<ModalSliceType>(),
  selectorArg2<string>(),
  (state, type, id) => {
    if (!id) {
      return type === state.type;
    }

    return type === state.type && id === state.id;
  },
);

export const selectModalData = createSelector(
  selectModalState,
  (modal) => modal.data,
);
